(function () {
	'use strict';
	var controllerId = 'richiestaFeriePermessiAddEdit';
	angular.module('app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', 'datacontext', 'richiesta', '$translate', richiestaFeriePermessiAddEditFn]);

	function richiestaFeriePermessiAddEditFn($scope, common, $uibModalInstance, datacontext, richiesta, $translate) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');

		$scope.dateOptions = {
			formatYear: 'yy',
			startingDay: 1
		};

		$scope.format = 'dd/MM/yyyy';
		$scope.richiesta = richiesta;
		$scope.titolo = $translate.instant('NuovaRichiesta');
		$scope.richieste_list = [];
		$scope.giustificativi = getGiustificativi();

		//inizializzazione
		if (richiesta.Id == 0) {
			$scope.richieste_list.push({
				Id: 0,
				TipoRichiesta: false
			});
		}
		else {
			$scope.titolo = $translate.instant('ModificaRichiesta');

			if ($scope.richiesta.DtInizio)
				$scope.richiesta.DtInizio = new Date($scope.richiesta.DtInizio);
			if ($scope.richiesta.DtFine)
				$scope.richiesta.DtFine = new Date($scope.richiesta.DtFine);

			$scope.richieste_list.push($scope.richiesta);
		}

		$scope.cancel = function () {
			if ($scope.richiesta == richiesta)
				$uibModalInstance.close("chiusoManualmente");			
		};

		//Gestione date
		$scope.dtInizio_opened = [];
		$scope.dtFine_opened = [];
		$scope.openDtInizio = function (index, event) {
			event.preventDefault();
			event.stopPropagation();

			$scope.dtInizio_opened[index] = !$scope.dtInizio_opened[index];
		}

		$scope.openDtFine = function (index, event) {
			event.preventDefault();
			event.stopPropagation();

			$scope.dtFine_opened[index] = !$scope.dtFine_opened[index];
		}

		$scope.ok = function () {
			
			var isValid = true;
			$scope.richieste_list.forEach(function (item) {
				//Validazione DataInizio < DataFine
				if (item.DtFine && item.DtInizio > item.DtFine) {
					logError($translate.instant('DataInizioMinoreDataFine'));
					isValid = false;
					return;
                }

                //Validazione richiesta a cavallo di due anni
                if (item.DtFine) {
                    if (new Date(item.DtInizio).getFullYear() != new Date(item.DtFine).getFullYear()) {
                        logError$translate.instant('RichiestaSuDueAnni');
                        isValid = false;
                        return;
                    }
                }

				//Validazione OraInizio < OraFine
				if (item.OraInizio && item.OraFine) {
					var dtInizio = new Date('01/01/2000 ' + item.OraInizio);
					var dtFine = new Date('01/01/2000 ' + item.OraFine);
					
					if (dtInizio >= dtFine) {
						logError($translate.instant('OraInizioMinoreOraFine'));
						isValid = false;
						return;
					}

					//Validazione OraFine - OraInizio > 30 minuti
					var difference = (dtFine - dtInizio) / 1000 / 60; //Minuti
					if (difference < 30) {
						logError($translate.instant('Intervallo30Minuti'));
						isValid = false;
						return;
					}
				}
			});			


			if (!isValid)
				return;


			if ($scope.richiesta.Id == 0) {
                datacontext.richiestaFerie_addMultiplo($scope.richieste_list).then(function (result) {
					if (result.status == 200) 
						$uibModalInstance.close(result);                    
                    else if (result == 409) 
                        logError($translate.instant('Data inserita già presente tra le richieste'));					
					else 
						logError($translate.instant('Errore durante la creazione del dato'));					
				});
			}
			else {
				var k = 0;
				for (var i = 0; i < $scope.richieste_list.length; i++) {
					datacontext.richiestaFerie_update($scope.richieste_list[i]).then(function (result) {
						if (result && result.Id)
							k++;
					});
				}

				setTimeout(function () {
					if (k == $scope.richieste_list.length)
						$uibModalInstance.close($scope.richiesta);
					else
						logError($translate.instant('Errore durante il salvataggio dei dati'));
				}, 500);
			}
		}

		$scope.add = function () {
			if ($scope.richieste_list.length > 3)
				logError($translate.instant('Non puoi aggiungere altre richieste al momento'));
			else {
				$scope.richieste_list.push({
					Id: 0,
					TipoRichiesta: false,
					RichiestaFerieId: 0
				});
			}
		}

		$scope.delete = function (index, obj_list) {
			var check_empty = 0;
			var check_full = obj_list.length;

			if (obj_list[index].Id != 0) {

				obj_list.forEach(function (obj) {
					if (obj.Id == 0) {
						check_empty++;
						check_full--;
					}
				});

				if ((check_full - check_empty) <= 0) {
					logError($translate.instant('Salva prima la richiesta sottostante'));
				}
				else {
					if ($scope.richieste_list.length < 2)
						logError($translate.instant('Non puoi rimuovere altre richieste al momento'));
					else {
						if ($scope.richieste_list[index].Id > 0) {
							datacontext.richiestaFerie_Dettaglio_delete($scope.richieste_list[index].Id).then(function () {

								$scope.richieste_list.splice(index, 1);
							});
						}
						else {
							$scope.richieste_list.splice(index, 1);
						}
					}
				}
			}
			else {
				if ($scope.richieste_list.length < 2)
					logError($translate.instant('Non puoi rimuovere altre richieste al momento'));
				else {
					if ($scope.richieste_list[index].Id > 0) {
						datacontext.richiestaFerie_Dettaglio_delete($scope.richieste_list[index].Id).then(function () {

							$scope.richieste_list.splice(index, 1);
						});
					}
					else {
						$scope.richieste_list.splice(index, 1);
					}
				}
			}
		}

		function getGiustificativi() {
			return datacontext.giustificativo_getAllList(true).then(function (data) {				
				return $scope.giustificativi = data;
			});
		}

		$scope.giustChanged = function (index) {
			if ($scope.richieste_list[index].GiustificativoId == 1) {
				$scope.richieste_list[index].OraInizio = null;
				$scope.richieste_list[index].OraFine = null;
			}
		}
	}
})();
